import React from "react";

const InputForm = () => {
  return (
    <div className="card border-0">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h4 className="card-title">IR8A Form</h4>
      </div>
      <div className="card-body">
        <div className="row form-row">
          <h4 className="header-title">Employee Details</h4>
          
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">First Name</label>
              <input type="text" className="form-control" />
            </div>
          </div>

          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">First Name</label>
              <input type="text" className="form-control" />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default InputForm;
